<!-- Cabecera institucional: franja azul con los logos de BonoGas y del FISE (diseño del equipo de Comunicaciones) -->
<header class="cabecera-fise">
    <img class="cabecera-fise__fondo" src="assets/images/cabecera-bonogas-fise.jpg" alt="" aria-hidden="true" />
    <div class="cabecera-fise__logos">
        <img src="assets/images/logos-bonogas-fise.png" alt="BonoGas - FISE Fondo de Inclusión Social Energético" />
    </div>
</header>
